export default "__VITE_ASSET__1f2d6f49__"